module.exports = __webpack_public_path__ + "media/images/pivotplanet-logo-450-52967920086f6dc76282a7a52c77eeb0845709f54600f57191bd51c9c6c78b73.png";